<template>
  <div>
    <CruiseMapMask
      v-if="!!selectedCruise"
      :selectedCruise="selectedCruise"
      :lnglat="[selectedCruise.longitude, selectedCruise.latitude]"
      @close="$emit('update:selectedId', '')"
      :showDetailBtn="showDetailBtn"
    />
  </div>
</template>

<script>
import CruiseMapMask from "~/components/cruise-map/cruise-map-mask.vue";

import { PointLayer } from "@antv/l7";
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  onUnmounted,
  ref,
  useStore,
  watch,
} from "@nuxtjs/composition-api";

const MAP_INSTANCE_KEY = `l7-map`;

export default defineComponent({
  name: "ship-overlay",
  components: { CruiseMapMask },
  props: {
    cruises: {
      type: Array,
      default: () => [],
    },
    selectedId: {
      type: String,
      default: "",
    },
    showDetailBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["click"],
  setup(props, { emit }) {
    const { map, scene } = inject(MAP_INSTANCE_KEY);
    const layer = ref(null);
    const store = useStore();
    const cruiseClasses = computed(
      () => store.getters["cruiseMap/cruiseClasses"]
    );
    const sourceData = computed(() => {
      return props.cruises.map((item) => {
        return {
          ...item,
          icon:
            props.selectedId === item.id
              ? `ship-${item.type}-on`
              : `ship-${item.type}-off`,
        };
      });
    });
    const selectedCruise = computed(() => {
      return props.cruises.find((item) => item.id == props.selectedId);
    });
    onMounted(() => {
      cruiseClasses.value.forEach((item) => {
        scene.value.addImage(`ship-${item.id}-on`, item.icon_on);
        scene.value.addImage(`ship-${item.id}-off`, item.icon_off);
      });
      // scene.value.addImage()
      layer.value = new PointLayer({
        name: "ship-layer",
        layerType: "point",
      })
        .source(sourceData.value, {
          parser: {
            type: "json",
            x: "longitude",
            y: "latitude",
          },
        })
        .shape("icon")
        .size([16, 42])
        .style({
          billboard: false,
          rotation: {
            field: "cog",
            value: (value) => {
              return value % 360 || 0;
            },
          },
        })
        .select(false);
      layer.value.on("click", (e) => {
        if (e.feature) {
          emit("click", e.feature);
        }
      });
      scene.value.addLayer(layer.value);
    });
    onUnmounted(() => {
      if (layer.value) {
        scene.value.removeLayer(layer.value);
      }
    });
    watch(
      () => sourceData.value,
      (values) => {
        layer.value.setData(values);
      }
    );
    return {
      selectedCruise,
    };
  },
});
</script>

<style lang="scss" scoped>

</style>
